export class School {
  schoolId: number;
  description: string;
  schoolNumber: number;
  manager: string;
  batch: string;
  serviceType: string;
  centerType: string;
  province: string;
  profitCenterCode: string;
}
